import type { CSSProperties } from 'react'

import type { FanTViewDto } from '@api'

import { CreatorAvatar } from '@/modules/creators/ui/CreatorAvatar'
import { classNames } from '@/utils/helpers'

interface Props {
  members?: FanTViewDto[]
  avatarClassName?: string
  size?: number
  isLoading?: boolean
}

const DEFAULT_AVATAR_SIZE = 50

export const ListMembersAvatars = ({
  members,
  avatarClassName,
  size = DEFAULT_AVATAR_SIZE,
  isLoading,
}: Props) => {
  const overlapOffset = size / 2 + 1

  let content =
    members &&
    members.length > 0 &&
    members.slice(0, 3).map((member, index) => {
      const { id, name, avatar } = member

      return (
        <CreatorAvatar
          key={id}
          name={name}
          size={size}
          avatarSrc={avatar}
          className={classNames(
            'absolute bottom-0 top-0 h-8 w-8 border-2 border-white dark:border-secondary-700',
            avatarClassName,
          )}
          style={{ left: index * overlapOffset }}
        />
      )
    })

  if (isLoading) {
    content = Array.from({ length: 3 }).map((_, index) => (
      <AvatarSkeleton
        key={index}
        size={size}
        className="absolute bottom-0 top-0 h-8 w-8 border-2 border-white dark:border-secondary-700"
        style={{ left: index * overlapOffset }}
      />
    ))
  }

  if (!content) return null

  const avatarsCount = isLoading ? 3 : Math.min(members?.length ?? 0, 3)

  const containerWidth = size + (avatarsCount - 1) * overlapOffset

  return (
    <div
      className="relative"
      style={{ width: containerWidth, height: size }}
    >
      {content}
    </div>
  )
}

interface AvatarSkeletonProps {
  size: number
  style?: CSSProperties
  className?: string
}

const AvatarSkeleton = ({ size, className, style }: AvatarSkeletonProps) => {
  return (
    <div
      className={classNames(
        'rounded-full bg-neutral-contrast dark:bg-card',
        className,
      )}
      style={{ width: size, height: size, ...style }}
    />
  )
}
